var BrowseNoDealsErrorPresenter, BrowseNoDealsErrorView, BrowseNoDealsMessageTemplate;

BrowseNoDealsErrorPresenter = require('../presenters/no_deals_error');

BrowseNoDealsMessageTemplate = require('../../no_deals_message.html.mustache');

module.exports = BrowseNoDealsErrorView = {
  template: BrowseNoDealsMessageTemplate,
  render: function(lastUpdatedRefinementId) {
    var noDealsHash;
    if (!(lastUpdatedRefinementId != null ? lastUpdatedRefinementId.length : void 0)) {
      return;
    }
    noDealsHash = BrowseNoDealsErrorPresenter.toHash(lastUpdatedRefinementId);
    if (noDealsHash) {
      return this.template.render(noDealsHash);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvdmlld3Mvbm9fZGVhbHNfZXJyb3IuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9icm93c2UvZnJvbnRlbmQvdmlld3Mvbm9fZGVhbHNfZXJyb3IuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsMkJBQUEsR0FBOEIsT0FBQSxDQUFRLDhCQUFSOztBQUM5Qiw0QkFBQSxHQUErQixPQUFBLENBQVEsc0NBQVI7O0FBRS9CLE1BQU0sQ0FBQyxPQUFQLEdBQWlCLHNCQUFBLEdBQ2Y7RUFBQSxRQUFBLEVBQVUsNEJBQVY7RUFFQSxNQUFBLEVBQVEsU0FBQyx1QkFBRDtBQUNOLFFBQUE7SUFBQSxJQUFBLG9DQUFjLHVCQUF1QixDQUFFLGdCQUF2QztBQUFBLGFBQUE7O0lBQ0EsV0FBQSxHQUFjLDJCQUEyQixDQUFDLE1BQTVCLENBQW1DLHVCQUFuQztJQUNkLElBQWlDLFdBQWpDO2FBQUEsSUFBQyxDQUFBLFFBQVEsQ0FBQyxNQUFWLENBQWlCLFdBQWpCLEVBQUE7O0VBSE0sQ0FGUiJ9
